import React from 'react';
import {
  EmptyShift,
  ShiftCourierJson,
  ShiftStatusType,
  UpdateType,
} from '../../../const/ShiftConst';
import { createShiftAsync } from 'fetch/shiftFetch';
import { Dayjs } from 'dayjs';
import './AddOpenSpotButton.scss';
import { Region } from '../../../types/orderTypes';

async function addOpenShift(
  date: Dayjs,
  UpdateShiftCourierListForDay: (
    shiftCourierList: ShiftCourierJson[],
    date: Dayjs,
    updateType: UpdateType
  ) => void,
  region: Region
) {
  const ShiftCourierResponse: ShiftCourierJson = await createShiftAsync(
    date,
    region
  );
  if (ShiftCourierResponse) {
    const newList: ShiftCourierJson[] = [
      {
        id: ShiftCourierResponse.id,
        name: EmptyShift.name,
        courierId: EmptyShift.courierId,
        note: EmptyShift.note,
        extraWork: EmptyShift.extraWork,
        status: ShiftStatusType.OPEN,
        shiftTravelMode: EmptyShift.shiftTravelMode,
      },
    ];
    UpdateShiftCourierListForDay(newList, date, UpdateType.ADD);
  }
}

export const AddOpenSpotButton = ({
  date,
  UpdateShiftCourierListForDay,
  region,
}: {
  date: Dayjs;
  UpdateShiftCourierListForDay: (
    shiftCourierList: ShiftCourierJson[],
    date: Dayjs,
    updateType: UpdateType
  ) => void;
  region: Region;
}): JSX.Element => {
  return (
    <div
      className="addOpenSpotBtnAdmin"
      onClick={async () =>
        await addOpenShift(date, UpdateShiftCourierListForDay, region)
      }
    >
      + open spot
    </div>
  );
};
